<mat-sidenav-container>
  <nav class="navbar">
    <div class="navbar-content">
      <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
        <i class="feather icon-menu"></i>
      </a>
      <div class="logo-mini-wrapper">
        <img src="../../../../assets/images/callcare/TSCSS_Logo_3.png" class="logo-mini logo-mini-light" alt="logo">
        <img src="../../../../assets/images/callcare/TSCSS_Logo_3.png" class="logo-mini logo-mini-dark" alt="logo">
      </div>

      <!-- ── Dynamic Page Header (Extraction Workspace, etc) ── -->
      <div class="dynamic-header-section" *ngIf="dynamicHeader">
        <div class="header-breadcrumb">
          <h1 class="header-title">{{ dynamicHeader.title }}</h1>
          <p class="header-subtitle" *ngIf="dynamicHeader.subtitle" [innerHTML]="dynamicHeader.subtitle"></p>
        </div>
        
        <div class="header-actions">
          <ng-container *ngFor="let action of dynamicHeader.actions">
            <!-- Normal Button -->
            <button *ngIf="!action.toggle" mat-button 
                    [class]="'action-btn ' + (action.class || '')"
                    (click)="onHeaderAction(action)" 
                    [matTooltip]="action.tooltip">
                <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                <span>{{ action.label }}</span>
            </button>
            
            <!-- Toggle Style Button -->
            <button *ngIf="action.toggle" mat-stroked-button 
                    [class]="'action-btn toggle-btn ' + (action.active ? 'active ' : '') + (action.class || '')"
                    (click)="onHeaderAction(action)" 
                    [matTooltip]="action.tooltip">
                <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                <span>{{ action.label }}</span>
            </button>
          </ng-container>
        </div>
      </div>

      <ul class="navbar-nav">
        <li class="theme-switcher-wrapper nav-item">
          <!-- <div *ngIf="showDialerButton" class="dialer-icon-wrapper">
            <button mat-fab extended class="dialer-fab-btn" type="button"
              (click)="openSidebar()" matTooltip="Open Dialer">
              <mat-icon class="dialer-fab-icon">phone_in_talk</mat-icon>
              <span class="dialer-fab-label">Dialer</span>
            </button>
          </div> -->

          <!-- Incoming Call Notification/Tab -->
          <div *ngIf="callerInfo && showTabDialer"
            class="incoming-call-info ms-3 p-2 bg-light border rounded shadow-sm d-flex align-items-center">
            <mat-icon class="text-primary me-2">call_received</mat-icon>
            <div>
              <p class="mb-0 fw-bold fs-12px">{{callerInfo.callerName}}</p>
              <p class="mb-0 text-muted fs-11px">{{callerInfo.callerPhoneNumber}}</p>
              <span *ngIf="callerInfo.found" class="badge bg-success fs-10px">Existing Customer</span>
              <span *ngIf="!callerInfo.found" class="badge bg-info fs-10px">New Caller</span>
            </div>
            <button mat-icon-button (click)="showTabDialer = false" class="ms-2">
              <mat-icon>close</mat-icon>
            </button>
          </div>

        </li>
        <li class="nav-item nav-profile" ngbDropdown>
          <p class="fs-12px text-secondary"
            style="margin: 10px 0px 5px 0px;font-weight: bolder;color: black!important;">{{userRole}}</p>
          <a class="nav-link" ngbDropdownToggle id="profileDropdown">
            <img class="w-30px h-30px ms-1 rounded-circle" src="images/callcare/user-avtar.png" alt="profile" width="30" height="30" fetchpriority="low">
          </a>
          <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
              <div class="mb-3">
                <img class="w-80px h-80px rounded-circle" src="images/callcare/user-avtar.png" alt="User avatar" width="80" height="80" fetchpriority="low">
              </div>
              <div class="text-center">
                <p class="fs-12px text-secondary">{{userName}}</p>
                <p class="fs-12px text-secondary">{{userEmail}}</p>
                <p class="fs-12px text-secondary">{{userRole}}</p>
              </div>
            </div>
            <ul class="list-unstyled p-1">
              <li>
                <a href="" (click)="onLogout($event)" class="dropdown-item py-2 d-flex ms-0">
                  <i class="feather icon-log-out me-2 icon-md"></i>
                  <span>Log Out</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</mat-sidenav-container>